module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-1_start-bd002d52ad6b2540a0cf9701b39f3729.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-1_start.png
// module id = 448
// module chunks = 2